"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarNoteTwoTone = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CalendarNoteTwoTone = function CalendarNoteTwoTone() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 3.316h1.167A2.325 2.325 0 0122.5 5.632v15.052A2.325 2.325 0 0120.167 23H3.833A2.325 2.325 0 011.5 20.684V5.632a2.325 2.325 0 012.333-2.316H5V1.579c0-.32.261-.579.583-.579H6.75c.322 0 .583.26.583.579v1.737h9.334V1.579c0-.32.26-.579.583-.579h1.167c.322 0 .583.26.583.579v1.737zM4 20.85h16V7.947H4V20.85z",
    clipRule: "evenodd"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M6 11.5a1 1 0 011-1h10a1 1 0 011 1v.25a1 1 0 01-1 1H7a1 1 0 01-1-1v-.25zM6 16a1 1 0 011-1h5a1 1 0 011 1v.333a1 1 0 01-1 1H7a1 1 0 01-1-1V16z",
    opacity: "0.72"
  }));
};

exports.CalendarNoteTwoTone = CalendarNoteTwoTone;